<div [id]="id" class="toast hide" style="min-width: 300px;">
  <div class="toast-header">
    <strong class="mr-auto">{{title}}</strong>
    <button aria-label="Close" class="ml-2 mb-1 close" data-dismiss="toast" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="toast-body">
    {{content}}
  </div>
</div>
